<template>
  <div id="root">
    <div v-if="isSignUp">
      <header>
        <div class="bg-gray-100">
          <div class="mx-auto container md:py-8 md:px-0">
            <div class="flex flex-col md:flex-row md:justify-between items-center mx-4">
              <div class="order-2 md:order-1 py-5 md:py-0">
                <img src="/images/CAL-Logo.png" width="225" height="46" alt="Construct-A-Lead"/>
              </div>
              <div
                  class="order-1 md:order-2 w-full md:w-auto md:shadow-md md:rounded-md bg-white px-3 py-2 md:py-1 leading-none align-middle text-center md:text-left">
                <a class="text-cal-blue font-bold uppercase text-xs no-underline" href="https://constructalead.com"><
                  Back to site</a>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-cal-blue">
          <div class="mx-auto container py-4 px-4 md:px-0">
            <div class="mx-4">
              <h1 class="text-lg font-bold text-white uppercase m-0 font-sans">Sign up</h1>
            </div>
          </div>
        </div>
      </header>
      <router-view
          keep-alive
          transition
          transition-mode="out-in">
      </router-view>
      <new-app-footer></new-app-footer>
    </div>
    <div v-else-if="!isLoggedIn">
      <main class="flex flex-col flex-1">
        <header class="header shadow-sm p-2 h-24">
          <div id="header-logo"><a href="/Projects" class="header-logo">
            CONSTRUCT-A-LEAD
          </a></div>
        </header>
        <div class="px-2 lg:px-6 mb-8 mt-24 lg:mt-4 ">
          <router-view
              class="view"
              keep-alive
              transition
              transition-mode="out-in">
          </router-view>
        </div>
      </main>
      <new-app-footer></new-app-footer>
    </div>
    <div class="h-full" v-else>
        <div :class="{'hidden': !open}" class="bg-black opacity-80 z-[901] fixed inset-0 lg:hidden" @click="open = !open"></div>
        <app-nav id="sidebar" class="z-[902]" :class="{'lg:w-80': showMenu, 'lg:w-28': !showMenu, 'hidden': !open}" :open="showMenu"></app-nav>
        <div class="hidden lg:block lg:fixed lg:top-9 z-[999]" :class="{'lg:left-80': showMenu, 'lg:left-28': !showMenu}">
        <button type="button" class="bg-cal-607FBC -translate-x-1/2	border-0 rounded-full	cursor-pointer hover:bg-white hover:border-cal-607FBC hover:border group" :class="{'rotate-180': showMenu}" @click="showMenu = !showMenu">
          <svg width="24" height="24" viewBox="0 0 24 24" role="presentation" class="fill-cal-607FBC overflow-hidden max-w-full max-h-full text-cal-607FBC align-bottom">
          <path d="M10.294 9.698a.988.988 0 010-1.407 1.01 1.01 0 011.419 0l2.965 2.94a1.09 1.09 0 010 1.548l-2.955 2.93a1.01 1.01 0 01-1.42 0 .988.988 0 010-1.407l2.318-2.297-2.327-2.307z" fill="currentColor" class="group-hover:fill-cal-607FBC fill-white" fill-rule="evenodd"></path>
          </svg>
        </button>
        </div>
        <main class="flex flex-col flex-1 h-full" :class="{'lg:pl-80': showMenu, 'lg:pl-28': !showMenu}">
          <header class="header shadow-sm p-2 h-16 lg:h-24 bg-cal-204285 from-cal-00194A to-cal-204285 bg-gradient-to-b lg:bg-none lg:bg-white">
            <button type="button" class="px-4 lg:border-r lg:border-gray-200 lg:text-gray-500 text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cal-71AF2F lg:hidden" @click="open = !open">
              <span class="sr-only">Open sidebar</span>
              <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h7"></path>
              </svg>
            </button>
            <app-header></app-header>
          </header>
          <div class="lg:hidden mt-16 bg-white p-3 shadow-sm capitalize text-cal-009588" v-if="title">{{ title }}</div>
          <!-- py-8 px-12 -->
          <div class="px-2 lg:px-6 mb-8 mt-2 lg:mt-4 flex-grow" :class="{ 'mt-2': title, 'mt-18': !title}">
            <router-view
                class="view w-full transition-opacity duration-200 ease-in"
                keep-alive
                transition
                transition-mode="out-in">
            </router-view>
          </div>
          <new-app-footer></new-app-footer>
        </main>
    </div>
    <trial-modal-view></trial-modal-view>
    <trial-signup-modal-view></trial-signup-modal-view>
  </div>
</template>

<script>

import auth from '../../services/Client/Auth.js';
import Main from '../Layout/Main.vue'
import AppHeader from './AppHeader.vue';
import AppNav from './AppNav.vue';
import AppFooter from '../Shared/AppFooter.vue';
import NewAppFooter from '../Shared/NewAppFooter.vue';
import TrialModalView from './TrialModalView.vue';
import TrialSignupModalView from './TrialSignupModalView.vue';
import VueButton from '../Shared/VueButton.vue';

export default {

  components: {Main, AppHeader, AppNav, AppFooter, NewAppFooter, TrialModalView, TrialSignupModalView, VueButton},

  mounted() {
    this.user = auth.user;
    this.isLoggedIn = auth.isLoggedIn();
    this.setAccountStyle(this.$route);
    this.isSignUp = this.$route.name.indexOf('signup') === 0;
    if (this.$route.meta && this.$route.meta.title) {
      this.title = this.$route.meta.title;
    }
  },

  data() {
    return {
      user: {},
      open: false,
      showMenu: JSON.parse(localStorage.getItem('show-menu') || true),
      isLoggedIn: false,
      isSignUp: false,
      title: '',
    }
  },

  methods: {

    setAccountStyle(route) {

      if (route.meta && route.meta.user) {
        this.onUserProfile = true
      } else {
        this.onUserProfile = false
      }
    },
  },

  watch: {
    'showMenu': function (value) {
      localStorage.setItem('show-menu', JSON.stringify(value));
    },
    '$root.$data.auth.user': {
      handler: function (val, oldVal) {
        this.setAccountStyle(this.$route);
      },
      deep: true
    },
    '$route': function (route) {
      this.setAccountStyle(route);
      this.isLoggedIn = auth.isLoggedIn();
      this.isSignUp = this.$route.name.indexOf('signup.') === 0;
      this.open = false;
      if (this.$route.meta && this.$route.meta.title) {
        this.title = this.$route.meta.title;
      } else {
        this.title = '';
      }
    }
  },
}
</script>
